import { createTanstackEndpoint } from "../utils/create-endpoint"
import { endpoints } from "./endpoints"

export const getOrganizationAccessContext = createTanstackEndpoint(
  endpoints.users.accessContext,
  "GET",
)
